
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as infoEY8WmXPnpDl5_45PjiVyaTUKdYloc3WcHiINRb4OlcbB4Meta } from "/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/info.vue?macro=true";
import { default as index8vfOBL4gQOF_45gdXomlOcFubSRk7CyPfzvEF4pfyzRrsMeta } from "/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/index.vue?macro=true";
import { default as registration0eus9wTZTlUV3YWVnKu2IGvpDGkLegaASc_eJL4KgyYMeta } from "/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/registration.vue?macro=true";
import { default as _91token_93DGgDK_45bwoQnsf3GnP2EN46K2U6OHZOXcKTRy4S3y9M0Meta } from "/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/submit/[token].vue?macro=true";
import { default as indexKRvontdyZ5Wt12InflJZXoVnu_45aoPK17qlggaef3fZsMeta } from "/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/government/index.vue?macro=true";
import { default as _91batchId_930_454QP2bX5_bZZ9HFc_45XgE3khuPVtzpEE_ImttLye4tcMeta } from "/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/results/[batchId].vue?macro=true";
import { default as _91id_93HAamhDAwJf7vOTAR4aIOFQgbCU0VlqRtIMTh5xkLGWQMeta } from "/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/government/submissions/[id].vue?macro=true";
import { default as indexiLJQsFAsvXBQbB_45WoenytuNIUUjhEgEVq17EK1ha41oMeta } from "/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/government/submissions/index.vue?macro=true";
export default [
  {
    name: "info",
    path: "/info",
    component: () => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/info.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/index.vue")
  },
  {
    name: "static-registration",
    path: "/static/registration",
    meta: registration0eus9wTZTlUV3YWVnKu2IGvpDGkLegaASc_eJL4KgyYMeta || {},
    component: () => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/registration.vue")
  },
  {
    name: "static-submit-token",
    path: "/static/submit/:token()",
    meta: _91token_93DGgDK_45bwoQnsf3GnP2EN46K2U6OHZOXcKTRy4S3y9M0Meta || {},
    component: () => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/submit/[token].vue")
  },
  {
    name: "static-government",
    path: "/static/government",
    meta: indexKRvontdyZ5Wt12InflJZXoVnu_45aoPK17qlggaef3fZsMeta || {},
    component: () => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/government/index.vue")
  },
  {
    name: "static-results-batchId",
    path: "/static/results/:batchId()",
    meta: _91batchId_930_454QP2bX5_bZZ9HFc_45XgE3khuPVtzpEE_ImttLye4tcMeta || {},
    component: () => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/results/[batchId].vue")
  },
  {
    name: "static-government-submissions-id",
    path: "/static/government/submissions/:id()",
    meta: _91id_93HAamhDAwJf7vOTAR4aIOFQgbCU0VlqRtIMTh5xkLGWQMeta || {},
    component: () => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/government/submissions/[id].vue")
  },
  {
    name: "static-government-submissions",
    path: "/static/government/submissions",
    meta: indexiLJQsFAsvXBQbB_45WoenytuNIUUjhEgEVq17EK1ha41oMeta || {},
    component: () => import("/home/runner/work/wdd-live/wdd-live/frontend/wdd/pages/static/government/submissions/index.vue")
  }
]